module.exports = __webpack_public_path__ + "img/symbol_4.770da4e1.png";